import classes from 'components/common/WidgetWithCards/WidgetCard/WidgetCardDivider/widgetCardDivider.module.scss';

interface ScoreCardDividerProps {
    variant?: 'bold' | 'normal';
}

export const WidgetCardDivider = ({ variant = 'normal' }: ScoreCardDividerProps) => {
    return <div className={classes[`${variant}`]} />;
};
